import { deletePricingTimeRequest } from "../../data/pricingTimeApi";

export async function deletePricingTimeUseCase(id) {
  if (!id) {
    throw new Error("El id es obligatorio.");
  }

  return await deletePricingTimeRequest(id);
}
